module.exports = __webpack_public_path__ + "img/ne.8b030478.svg";